module.exports = __webpack_public_path__ + "static/media/customisable_solutions.6b26a281.png";